<div class="flex flex-col justify-center items-center mb-4">
  <a
    class="text-gray-700 focus:underline focus:outline-none"
    href="https://schenk-sonnenschutztechnik.de/impressum"
    tilte="Schenk Sonnenschutztechnik — Impressum"
    >Impressum</a
  >
  <a
    class="text-gray-700 focus:underline focus:outline-none"
    href="https://schenk-sonnenschutztechnik.de/datenschutz"
    tilte="Schenk Sonnenschutztechnik — Datenschutz"
    >Datenschutz</a
  >
  <p class="text-center text-xs text-gray-600 mt-1">
    © {{year}} — Schenk Sonnenschutztechnik GmbH — v{{version}}
  </p>
</div>
